import React from "react";
import { Alert, Button } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import moment from "moment";
import { useHistory, useLocation } from "react-router-dom";
import { readChecklistWindow, searchWithoutChecklistWindow } from "../../util/checklistWindow";
import "./ChecklistWindowBanner.css";

/**
 * Banner shown on a list opened from the Payroll Checklist with ?from&to.
 * "Show all" drops only the period from the URL (tab/status stay) and calls
 * onShowAll so the screen can reload its list.
 * `describe(from, to)` replaces the default "Showing only {label} from ..." text
 * for checks whose rule is not "inside the period".
 */
const ChecklistWindowBanner = ({ onShowAll, label = "requests", describe }) => {
  const location = useLocation();
  const history = useHistory();
  const period = readChecklistWindow(location.search);
  if (!period) return null;

  const from = moment(period.checklist_from, "YYYY-MM-DD").format("DD MMM YYYY");
  const to = moment(period.checklist_to, "YYYY-MM-DD").format("DD MMM YYYY");
  const showAll = () => {
    history.replace(`${location.pathname}${searchWithoutChecklistWindow(location.search)}`);
    if (onShowAll) onShowAll();
  };

  return (
    <Alert
      type="info"
      showIcon
      icon={<CalendarOutlined />}
      className="checklist-window-banner"
      message={
        describe ? (
          <>
            {describe(from, to)}
            <span className="checklist-window-banner__source">· Payroll Checklist</span>
          </>
        ) : (
          <>
            Showing only {label} from{" "}
            <span className="checklist-window-banner__period">{from} – {to}</span>
            <span className="checklist-window-banner__source">· Payroll Checklist period</span>
          </>
        )
      }
      action={
        <Button size="small" className="checklist-window-banner__show-all" onClick={showAll}>
          Show all
        </Button>
      }
    />
  );
};

export default ChecklistWindowBanner;
